import { useEffect, useState } from "react";
import { createPortal } from "react-dom";
import Toast from "./Toast";
import { ToastContainerProps, ToastProps } from "./Toast.types";

const positionClasses = {
	"top-left": "top-4 left-4",
	"top-center": "top-4 left-1/2 transform -translate-x-1/2",
	"top-right": "top-4 right-4",
	"bottom-left": "bottom-4 left-4",
	"bottom-center": "bottom-4 left-1/2 transform -translate-x-1/2",
	"bottom-right": "bottom-4 right-4"
};

interface ToastContainerComponentProps extends ToastContainerProps {
	toasts: ToastProps[];
	onRemoveToast: (id: string) => void;
}

export default function ToastContainer({
	toasts,
	onRemoveToast,
	position = "bottom-right",
	maxToasts = 5,
	autoClose = 3000,
	pauseOnHover = true,

	hideProgressBar = false,
	closeOnClick = true,
	draggable = true,
	className = ""
}: ToastContainerComponentProps) {
	const [mounted, setMounted] = useState(false);
	const displayedToasts = toasts.slice(0, maxToasts);

	useEffect(() => {
		setMounted(true);
	}, []);

	if (!mounted) return null;

	const containerElement = (
		<section
			className={`fixed z-[99999] pointer-events-none inset-0 ${className}`}
			aria-label="Toast notifications"
			style={{ pointerEvents: "none" }}
		>
			<div
				className={`absolute pointer-events-auto ${positionClasses[position]}`}
			>
				{displayedToasts.map((toast) => (
					<Toast
						key={toast.id}
						{...toast}
						onRemove={onRemoveToast}
						autoClose={autoClose}
						pauseOnHover={pauseOnHover}
						hideProgressBar={hideProgressBar}
						closeOnClick={closeOnClick}
						draggable={draggable}
					/>
				))}
			</div>
		</section>
	);

	return createPortal(containerElement, document.body);
}
